
import * as Yup from 'yup';
import { getRequest, putRequest } from '../../../services/httpService';

export type BlankEnum = '';
export type NullEnum = 'NULL';


export type DenudedTechniqueEnum = 'MECHANICAL_DENUDATION' | 'ENZYMATIC_DENUDATION' | 'COMBINED_MECHANICAL';
export type IncubatorEnum = 'HERA_CELL' | 'MINC_K_SYSTEMS' | 'MEDGYN' | 'OOSAFE' | 'VITROLIFE' | 'IVF_TECH';
export type GradeEnum = 'GV' | 'M I' | 'M II' | 'DEGENERATED';
export type DispositionEnum = 'MATURATION' | 'FREEZE' | 'DISCARD';
// Enum for Cryo Purpose
export type CryoPurposeEnum = 'PRESERVATION_OF_EXCESS_EMBRYOS'| 'TIMED_EMBRYO_TRANSFER'| 'FERTILITY_PRESERVATION'| 'GENETIC_TESTING'| 'FLEXIBLE_FAMILY_PLANNING'| 'REDUCING_MULTIPLE_PREGNANCIES';
// Enum for Media Choices
export type MediaEnum = 'KITAZATO' | 'SWEMED' | 'IRVINE_SCIENTIFIC';

// Dropdown Items for disposition
export const getDispositionItems = (tOocyteGrading: (key: string) => string): { label: string; value: DispositionEnum }[] => [
  { label: tOocyteGrading('maturation'), value: 'MATURATION' },
  { label: tOocyteGrading('freeze'), value: 'FREEZE' },
  { label: tOocyteGrading('discard'), value: 'DISCARD' },
];

// Dropdown Items for Grade
export const getGradeItems = (tOocyteGrading: (key: string) => string): { label: string; value: GradeEnum }[] => [
  { label: tOocyteGrading('gv'), value: 'GV' },
  { label: tOocyteGrading('mi'), value: 'M I' },
  { label: tOocyteGrading('mii'), value: 'M II' },
  { label: tOocyteGrading('degenerated'), value: 'DEGENERATED' },
];

// Dropdown Items for Incubators
export const incubatorItems: { label: string; value: IncubatorEnum }[] = [
  { label: 'HeraCell', value: 'HERA_CELL' },
  { label: 'MINCKSystems', value: 'MINC_K_SYSTEMS' },
  { label: 'MedGyn', value: 'MEDGYN' },
  { label: 'Oosafe', value: 'OOSAFE' },
  { label: 'Vitrolife', value: 'VITROLIFE' },
  { label: 'IVFTech', value: 'IVF_TECH' },
];
// Incubator API response interfaces
export interface IncubatorTranslations {
  [lang: string]: string;
}

export interface IncubatorObject {
  id: number;
  name_label: string;
  created_on: string;
  updated_on: string;
  deleted_on: string | null;
  deleted_reason: string | null;
  name: string;
  is_active: boolean;
  capacity: number;
  specimen: string;
  translations: IncubatorTranslations;
  tenant: number;
}

export interface IncubatorApiResponse {
  meta: PaginationInfo;
  objects: IncubatorObject[];
}

export interface OocyteDetailsType {
    oocyte_count: number;
    denuded_date: string;
    denuded_start_time: string;
    denuded_end_time: string;
    denuded_by: number | null;
    denuded_technique: string | null; 
    embryologist: number | null;
    witness: number | null;
    remarks?: string | null;
    incubator: number | null;  
    cycle:number | null 
}

export const initialValuesOD:OocyteDetailsType = {
  oocyte_count: 0,
  denuded_date: '',
  denuded_start_time: '',
  denuded_end_time: '',
  denuded_by: null,
  denuded_technique: '',
  embryologist: null,
  witness: null,
  remarks: '',
  incubator: null,
  cycle:null
};

export interface OocyteCycleSummaryType {
  cycle: number | null;
  remarks?: string | '';
  oocytes: number[] | null; 
  grade?: string | ''; 
  disposition?: string | '';
  cryo_date?: string | null;
  cryo_preserved_by?: number | null;
  cryo_purpose?: string | null;
  media?: string | null;
  cryo_media?: string | null;
  screening_status?: string | null;
  status?: string | null;
  tank?: number | null;
  canister?: number | null;
  cane?: number | null;
  goblet?: number | null;
  goblet_color?: string | null;
  cryotech?: number | null;
  cryotech_color?: string | null;
  locations?:number | null;  
  files?: { file: string }[] | null;
  cryo_preserved_date?: string | null;
}

export const initialCycleSummary: OocyteCycleSummaryType = {
  cycle: null,
  remarks: '',
  oocytes: [],
  grade: '',
  disposition: '',
  cryo_date: null,
  cryo_preserved_by:null,
  cryo_purpose: null,
  media: null,
  cryo_media: null,
  screening_status: null,
  status:'DRAFT',

  tank:null,
  canister:null,
  cane:null,
  goblet:null,  
  goblet_color: '', 
  cryotech: null,
  cryotech_color: null,
  locations: null
};

export const OocyteCycleSummaryValidationSchema = (tOocyteGrading: (key: string) => string) => Yup.object().shape({
  OocyteCycleSummary: Yup.array().of(
    Yup.object().shape({
      cycle: Yup
        .number()
        .nullable(),
  
      remarks: Yup
        .string()
        .nullable()
        .max(1000, tOocyteGrading('remarksCannotExceed1000Characters')),

      oocytes: Yup
        .array(),

      grade: Yup
        .string()
        .required(tOocyteGrading('gradeIsRequired'))
        .oneOf(['GV', 'M I', 'M II', 'DEGENERATED'], tOocyteGrading('GrademustbeoneofGVM1M2MI')),

      disposition: Yup
        .string()
        .required(tOocyteGrading('dispositionIsRequired')) 
        .oneOf(['MATURATION', 'DISCARD', 'FREEZE', 'TRANSFER'], tOocyteGrading('dispositionMustBeOneOf')),

    })
  )
});
  
export const oocyteDetailsValidationSchema = (tOocyteGrading: (key: string) => string) =>
  Yup.object().shape({
    OocyteDetails: Yup.array().of(
      Yup.object().shape({
        oocyte_count: Yup.number()
          .min(1, tOocyteGrading('oocyteRetrievedMustBeAtLeast1')),
        denuded_date: Yup.date()
          .required(tOocyteGrading('denudingDateIsRequired')),
        denuded_start_time: Yup.string()
          .required(tOocyteGrading('startTimeIsRequired')),
        denuded_end_time: Yup.string()
          .required(tOocyteGrading('endTimeIsRequired'))
          .test(
            'is-after-start-time',
            tOocyteGrading('endTimeMustBeAfterStartTime'),
            function (value) {
              const { denuded_start_time } = this.parent;
              return value && denuded_start_time ? value > denuded_start_time : true;
            }
          ),
        denuded_by: Yup.number()
          .required(tOocyteGrading('denudedByIsRequired')),

        denuded_technique: Yup.mixed<DenudedTechniqueEnum | BlankEnum >()
          .oneOf(['MECHANICAL_DENUDATION', 'ENZYMATIC_DENUDATION', 'COMBINED_MECHANICAL', '',])
          .required(tOocyteGrading('denudedTechniqueIsRequired')),
    
        embryologist: Yup.number()
          .required(tOocyteGrading('embryologistNameIsRequired')),

        witness: Yup.number()
          .required(tOocyteGrading('witnessEmbryologistNameIsRequired'))
          .test('not-same', tOocyteGrading('witnessCannotBeSameAsEmbryologist'), function (value) {
            const { embryologist } = this.parent; // Accessing the sibling field
            return value !== embryologist; // Validate that they are not the same
          }),

        remark: Yup.string()
          .nullable()
          .max(200, tOocyteGrading('remarkMustNotExceed200Characters')),
        incubator: Yup.number().required(tOocyteGrading('incubatorIsRequired')),
      })
    )
  });

 

export const CombinedValidationSchema = (tOocyteGrading: (key: string) => string) =>
  oocyteDetailsValidationSchema(tOocyteGrading).concat(OocyteCycleSummaryValidationSchema(tOocyteGrading));


// Function to update oocyte details
export function updateOocyteDetails(id: number, data: OocyteDetailsType): Promise<OocyteDetailsType> {
  const url = `/oocyte-details/${id}/details/`;
  return putRequest(url, data, { responseType: 'json' });
}


// Function to update oocyte details
export function updateOocyteSummary(id: number, data: OocyteCycleSummaryType): Promise<OocyteCycleSummaryType> {
  const url = `/oocyte/cycle/${id}/`;
  return putRequest(url, data, { responseType: 'json' });
}

 
// Function to get oocyte retrieval
export function getOocyteRetrieval(id: number): Promise<OocyteDetailsType> {
  const url =`oocyte-details/${id}`;
  return getRequest(url, { responseType: 'json' });
}


export function getOocyteSummaryIDwise(id: number): Promise<OocyteCycleSummaryType> {
  const url =`oocyte-details/${id}`;
  return getRequest(url, { responseType: 'json' });
}

export interface OocyteRow {
  id: number;
  cycle: number;
  remarks: string | null;
  oocyte_number: number;
  grade: string | null;
  grade_label: string | null;
  location: string | null;
  disposition: string | null; 
  cryo_preserved_date: string | null;
  cryo_preserved_by: number | null;
  cryo_purpose: string | null;
  is_screened: boolean;
  oocyte_no?: string | null;
  status?: string;
  cryo_media?: string | null;
  files_url?: string | null;
  location_details?: LocationDetails;
  files?: OocyteFile[];
}
export function getOocyteSummaryTable(id: number): Promise<OocyteRow[]> { // Change to return an array of OocyteRow
  const url = `cycle/${id}/oocytes`;
  return getRequest(url, { responseType: 'json' });
}

export function deleteOocytes(id: number ): Promise<void> {
  const url = `/oocyte/${id}/deactivate/`;
  return putRequest(url, { responseType: 'json' });
}

export interface OocyteDetails {
  oocyte_number: number;
  isFilled: boolean;
}


const generateRadialGradient = (progress: number) => {
  const startColor = `rgba(255, ${Math.max(0, 255 - progress * 2)}, ${Math.max(0, 255 - progress * 3)}, 1)`; // Start color varies with progress
  const endColor = `rgba(${Math.min(255, progress * 3)}, 174, 202, 1)`; // End color varies with progress
  return `radial-gradient(circle, ${startColor} 0%, ${endColor} 100%)`;
};

export function fetchMasterData(type: string): Promise<OocyteDetailsType> {
  const url = `clinics/configuration/?module_type=oocyte_grading&type=${type}`;
  return getRequest(url, { responseType: 'json' });
}

export function fetchIncubators(specimen: string): Promise<IncubatorApiResponse> {
  const url = `/incubator/?specimen=${specimen}`;
  return getRequest(url, { responseType: 'json' });
}


// Define a constant for roles to avoid magic strings
export const ROLES = ['DOCTOR', 'ANESTHETIST', 'EMBRYOLOGIST', 'NURSE'] as const;

export interface Clinician {
  id: number; 
  first_name: string;
  last_name: string;
  // Add other relevant fields as per your API response
}

// Create a type that represents the role strings
export type Role = typeof ROLES[number]; // 'DOCTOR' | 'ANESTHETIST' | 'EMBRYOLOGIST' | 'NURSE'



export const tanks = [
  { 
    name: 'Tank 1', 
    progress: 10, 
    canisters: [
      { 
        name: 'Canister 1', 
        progress: 30, 
        canes: [
          {
            name: 'Cane 1',
            progress: 30,
            goblets: [
              { 
                name: 'Goblet 1',
                color: generateRadialGradient(40), 
                progress: 40,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 1', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 2', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 3', filled: false },

                  { color: generateRadialGradient(40), name: 'Cryotech 3', filled: false },

                  { color: generateRadialGradient(40), name: 'Cryotech 2', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 2', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 2', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 2', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 3', filled: false },
                ],
              },
              { 
                name: 'Goblet 2',
                color: generateRadialGradient(40), 
                progress: 50,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 4', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 5', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 6', filled: false },
                ],
              },
              { 
                name: 'Goblet 3',
                color: generateRadialGradient(40), 
                progress: 60,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 7', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 8', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 9', filled: false },
                ],
              },
            ],
          },
          {
            name: 'Cane 2',
            progress: 40,
            goblets: [
              { 
                name: 'Goblet 1',
                progress: 50,
                color: generateRadialGradient(50), 
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 10', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 11', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 12', filled: false },
                ],
              },
              { 
                name: 'Goblet 2',
                color: generateRadialGradient(50), 
                progress: 60,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 13', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 14', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 15', filled: false },
                ],
              },
              { 
                name: 'Goblet 3',
                color: generateRadialGradient(50), 
                progress: 70,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 16', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 17', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 18', filled: false },
                ],
              },
            ],
          },
          {
            name: 'Cane 3',
            progress: 50,
            goblets: [
              { 
                name: 'Goblet 1',
                color: generateRadialGradient(60), 
                progress: 60,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 19', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 20', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 21', filled: false },
                ],
              },
              { 
                name: 'Goblet 2',
                color: generateRadialGradient(60), 
                progress: 70,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 22', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 23', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 24', filled: false },
                ],
              },
              { 
                name: 'Goblet 3',
                color: generateRadialGradient(60), 
                progress: 80,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 25', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 26', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 27', filled: false },
                ],
              },
            ],
          },
        ],
      },
      { 
        name: 'Canister 2', 
        progress: 40,
        canes: [
          {
            name: 'Cane 1',
            progress: 30,
            goblets: [
              { 
                name: 'Goblet 1',
                color: generateRadialGradient(40), 
                progress: 40,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 1', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 2', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 3', filled: false },
                ],
              },
              { 
                name: 'Goblet 2',
                color: generateRadialGradient(40), 
                progress: 50,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 4', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 5', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 6', filled: false },
                ],
              },
              { 
                name: 'Goblet 3',
                color: generateRadialGradient(40), 
                progress: 60,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 7', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 8', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 9', filled: false },
                ],
              },
            ],
          },
          {
            name: 'Cane 2',
            progress: 40,
            goblets: [
              { 
                name: 'Goblet 1',
                color: generateRadialGradient(40), 
                progress: 50,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 10', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 11', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 12', filled: false },
                ],
              },
              { 
                name: 'Goblet 2',
                color: generateRadialGradient(40), 
                progress: 60,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 13', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 14', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 15', filled: false },
                ],
              },
              { 
                name: 'Goblet 3',
                color: generateRadialGradient(40), 
                progress: 70,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 16', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 17', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 18', filled: false },
                ],
              },
            ],
          },
          {
            name: 'Cane 3',
            progress: 50,
            goblets: [
              { 
                name: 'Goblet 1',
                color: generateRadialGradient(50), 
                progress: 60,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 19', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 20', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 21', filled: false },
                ],
              },
              { 
                name: 'Goblet 2',
                progress: 70,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 22', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 23', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 24', filled: false },
                ],
              },
              { 
                name: 'Goblet 3',
                color: generateRadialGradient(50), 
                progress: 80,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 25', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 26', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 27', filled: false },
                ],
              },
            ],
          },
        ],
      },
      { 
        name: 'Canister 3', 
        progress: 50,
        canes: [
          {
            name: 'Cane 1',
            progress: 30,
            goblets: [
              { 
                name: 'Goblet 1',
                color: generateRadialGradient(60), 
                progress: 40,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 1', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 2', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 3', filled: false },
                ],
              },
              { 
                name: 'Goblet 2',
                color: generateRadialGradient(60), 
                progress: 50,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 4', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 5', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 6', filled: false },
                ],
              },
              { 
                name: 'Goblet 3',
                color: generateRadialGradient(60), 
                progress: 60,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 7', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 8', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 9', filled: false },
                ],
              },
            ],
          },
          {
            name: 'Cane 2',
            color: generateRadialGradient(60), 
            progress: 40,
            goblets: [
              { 
                name: 'Goblet 1',
                color: generateRadialGradient(60), 
                progress: 50,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 10', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 11', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 12', filled: false },
                ],
              },
              { 
                name: 'Goblet 2',
                color: generateRadialGradient(60), 
                progress: 60,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 13', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 14', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 15', filled: false },
                ],
              },
              { 
                name: 'Goblet 3',
                color: generateRadialGradient(60), 
                progress: 70,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 16', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 17', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 18', filled: false },
                ],
              },
            ],
          },
          {
            name: 'Cane 3',
            progress: 50,
            goblets: [
              { 
                name: 'Goblet 1',
                color: generateRadialGradient(60), 
                progress: 60,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 19', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 20', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 21', filled: false },
                ],
              },
              { 
                name: 'Goblet 2',
                color: generateRadialGradient(60), 
                progress: 70,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 22', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 23', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 24', filled: false },
                ],
              },
              { 
                name: 'Goblet 3',
                color: generateRadialGradient(60), 
                progress: 80,
                cryotech: [
                  { color: generateRadialGradient(40), name: 'Cryotech 25', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 26', filled: false },
                  { color: generateRadialGradient(40), name: 'Cryotech 27', filled: false },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
  


// Dropdown Items for Cryo Purpose
export const cryoPurposeItems: { label: string; value: CryoPurposeEnum }[] = [
  { label: 'Preservation of Excess Embryos', value: 'PRESERVATION_OF_EXCESS_EMBRYOS' },
  { label: 'Timed Embryo Transfer', value: 'TIMED_EMBRYO_TRANSFER' },
  { label: 'Fertility Preservation', value: 'FERTILITY_PRESERVATION' },
  { label: 'Genetic Testing', value: 'GENETIC_TESTING' },
  { label: 'Flexible Family Planning', value: 'FLEXIBLE_FAMILY_PLANNING' },
  { label: 'Reducing Multiple Pregnancies', value: 'REDUCING_MULTIPLE_PREGNANCIES' },
];


// Dropdown Items for Media Choices
export const mediaItems: { label: string; value: MediaEnum }[] = [
  { label: 'kitazato', value: 'KITAZATO' },
  { label: 'swemed', value: 'SWEMED' },
  { label: 'irvineScientific', value: 'IRVINE_SCIENTIFIC' },
];

export interface OocyteFile {
  id: number;
  file: string; // URL of the file
  file_proxy_url?: string | null; // Proxy URL of the file (if applicable)
}

export interface OocyteInfo {
  id: number;
  oocyte_no?: string | null;
  cycle: number;
  remarks: string | null;
  oocyte_number: number;
  grade: string | null;
  grade_label: string | null;
  location: string | null;
  disposition: string | null; 
  cryo_preserved_date: string | null;
  cryo_preserved_by: number | null;
  cryo_purpose: string | null;
  status?:string,
  is_screened: boolean;
  image?: string | null; // Add image property (if applicable)
  cryo_media?: string | null;
  files_url ?: string | null;
  location_details?: LocationDetails; 
  files?: OocyteFile[];
}

export interface LocationDetails {
  id: number;
  reference_id: string;
  plan: number;
  parents: Array<{
    id: number;
    reference_id: string | null;
    plan: number;
    level: number;
    name: string;
    name_label?: string;
    parent: number | null;
    occupancy: number;
    hierarchy: string;
    specimen: string | null;
    is_occupied: boolean;
    is_leaf: boolean;
    color: string | null;
  }>;
  level: number;
  name: string;
  parent: number;
  occupancy: number;
  hierarchy: string;
  specimen: string;
  is_occupied: boolean;
  color: string;
}

export interface StorageResponse {
  meta: PaginationInfo;
  objects: StorageUnit[];
}

export interface PaginationInfo {
  limit: number;
  next: string | null;
  offset: number;
  previous: string | null;
  total_count: number;
}

export interface StorageUnit {
  id: number;
  created_on: string;
  updated_on: string;
  deleted_on: string | null;
  root_name: string;
  depth: number;
  root_capacity: number;
  specimens: string;
  is_finalized: boolean;
  tenant: number;
  clinic: number;
}


// Media enum array with localization
export const mediaOptionsLocalized = [
  { code: 'KITAZATO', description: { en: 'Kitazato', es: 'Kitazato', hi: 'किताजातो', pt: 'Kitazato' } },
  { code: 'SWEMED', description: { en: 'Swemed', es: 'Swemed', hi: 'स्वेमेड', pt: 'Swemed' } },
  { code: 'IRVINE_SCIENTIFIC', description: { en: 'Irvine Scientific', es: 'Irvine Científico', hi: 'अर्विन साइंटिफिक', pt: 'Irvine Científico' } },
];
